import React from 'react';
import {
  LayoutDashboard,
  Wallet,
  HandCoins,
  Users,
  Settings,
  type LucideIcon,
} from 'lucide-react';
import { canAccessNav } from '../lib/permissions';
import { useTranslation } from '../lib/i18n';

interface BottomNavItem {
  id: string;
  /** Compact label for the bottom bar (always mobile). */
  labelKey: string;
  icon: LucideIcon;
}

const items: BottomNavItem[] = [
  { id: 'dashboard', labelKey: 'nav.home', icon: LayoutDashboard },
  { id: 'finance', labelKey: 'nav.financeShort', icon: Wallet },
  { id: 'loans', labelKey: 'nav.loansShort', icon: HandCoins },
  { id: 'customers', labelKey: 'nav.clientsShort', icon: Users },
  { id: 'settings', labelKey: 'nav.settingsShort', icon: Settings },
];

interface BottomNavProps {
  activeItem: string;
  setActiveItem: (id: string) => void;
}

export function BottomNav({ activeItem, setActiveItem }: BottomNavProps) {
  const { t } = useTranslation();
  const visible = items.filter((item) => canAccessNav(item.id));

  return (
    <nav className="app-bottom-nav lg:hidden" aria-label="Primary">
      <div
        className="app-bottom-nav-inner"
        style={{ gridTemplateColumns: `repeat(${Math.max(visible.length, 1)}, minmax(0, 1fr))` }}
      >
        {visible.map((item) => {
          const active = activeItem === item.id;
          const Icon = item.icon;
          const label = t(item.labelKey);
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => setActiveItem(item.id)}
              aria-current={active ? 'page' : undefined}
              aria-label={label}
              title={label}
              className={`app-bottom-nav-btn ${active ? 'app-bottom-nav-btn-active' : ''}`}
            >
              <span className="app-bottom-nav-icon">
                <Icon className="h-[18px] w-[18px]" strokeWidth={active ? 2.5 : 2} />
              </span>
              <span className="app-bottom-nav-label">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
